(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TempCustomerDialogController', TempCustomerDialogController);

    TempCustomerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TempCustomer', 'DoctorSpecialty', 'CustomerCategory', 'CustomerSector', 'CustomerTitle', 'CustomerSubCategory', 'Customer', 'TempCustomerSector', 'Employee', 'CustomerType', 'Collaboration'];

    function TempCustomerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TempCustomer, DoctorSpecialty, CustomerCategory, CustomerSector, CustomerTitle, CustomerSubCategory, Customer, TempCustomerSector, Employee, CustomerType, Collaboration) {
        var vm = this;
        vm.tempCustomer = entity;
        vm.doctorspecialties = DoctorSpecialty.query();
        vm.customercategories = CustomerCategory.query();
        vm.customersectors = CustomerSector.query();
        vm.customertitles = CustomerTitle.query();
        vm.customersubcategories = CustomerSubCategory.query();
        vm.customers = Customer.query();
        vm.tempcustomersectors = TempCustomerSector.query();
        vm.employees = Employee.query();
        vm.customertypes = CustomerType.query();
        vm.collaborations = Collaboration.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:tempCustomerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tempCustomer.id !== null) {
                TempCustomer.update(vm.tempCustomer, onSaveSuccess, onSaveError);
            } else {
                TempCustomer.save(vm.tempCustomer, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.issuedDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
